
const ext = '.aspx'; // .aspx .php .jsp ...

export const environment = {
  Dynamsoft: {
    resourcesPath: 'Resources',
    dwtProductKey: 'f0069uQAAAKoRHbi1whAUpglfQra43Dc/PxRswgkNn3Tjta7DTaWb+07RTfqLcg4N5Fq7rg9z5GjapMKMOP8iAa1zn9dNTVaE',
    serviceInstallerLocation: 'https://demo.dynamsoft.com/DWT/Resources/dist/18.4.2/',

    uploadTargetURL: 'SaveToFile' + ext,
    downloadUploadedFileURL: 'Download' + ext + '?ImageName=',
    removeUploadedFileURL: 'DeleteFile' + ext + '?ImageName='

  },
  debug: false
};
